import React, { useEffect, useRef, useState } from "react";

const useNearScreen = () => {
  const [isNearScreen, setShow] = useState(false);
  const elementRef = useRef();

  useEffect(function () {
    let observer;
    const onChange = (entries, observer) => {
      const el = entries[0];
      if (el.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    };
    Promise.resolve(
      typeof IntersectionObserver !== "undefined"
        ? IntersectionObserver
        : import("intersection-observer")
    ).then(() => {
      observer = new IntersectionObserver(onChange, {
        rootMargin: "100px",
      });
      if (elementRef.current && elementRef.current instanceof Element) {
        observer.observe(elementRef.current);
      }
    });
    return () => observer && observer.disconnect();
  });
  return { isNearScreen, elementRef };
};

export default useNearScreen;
